/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Value } from './Value.js';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value.js';

/**
 * 
 * @export
 * @interface CreateContactEntryRequest
 */
export interface CreateContactEntryRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateContactEntryRequest
     */
    contactId?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateContactEntryRequest
     */
    fieldId?: number;
    /**
     * 
     * @type {Value}
     * @memberof CreateContactEntryRequest
     */
    value?: Value;
    /**
     * 
     * @type {string}
     * @memberof CreateContactEntryRequest
     */
    searchResultId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateContactEntryRequest
     */
    suggestionId?: number;
}

/**
 * Check if a given object implements the CreateContactEntryRequest interface.
 */
export function instanceOfCreateContactEntryRequest(value: object): boolean {
    return true;
}

export function CreateContactEntryRequestFromJSON(json: any): CreateContactEntryRequest {
    return CreateContactEntryRequestFromJSONTyped(json, false);
}

export function CreateContactEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateContactEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'fieldId': json['fieldId'] == null ? undefined : json['fieldId'],
        'value': json['value'] == null ? undefined : ValueFromJSON(json['value']),
        'searchResultId': json['searchResultId'] == null ? undefined : json['searchResultId'],
        'suggestionId': json['suggestionId'] == null ? undefined : json['suggestionId'],
    };
}

export function CreateContactEntryRequestToJSON(value?: CreateContactEntryRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contactId': value['contactId'],
        'fieldId': value['fieldId'],
        'value': ValueToJSON(value['value']),
        'searchResultId': value['searchResultId'],
        'suggestionId': value['suggestionId'],
    };
}

